<template>
    <div class="modal fade" id="priceDescModel"  :class="{ in: isShowModal, active: isShow}"
        tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" v-show="isShow">
        <div class="modal-bg" @click="onModalClose"></div>
        <div class="modal-dialog" style="width: 590px;">
            <div class="modal-content">
                <div class="common-modal-close" data-dismiss="modal" aria-label="Close" @click="onModalClose">
                    <img class="common-modal-close" src="https://resource.rcclchina.com.cn/TUI2PCImg/SearchPackage/modal-close.jpg">
                </div>

                <div class="modal-body">
                    <div class="list-price-ins-title">价格说明</div>
                    <div class="list-price-ins-head">早订特惠价</div>
                    <div class="list-price-ins-text">为鼓励客人尽早计划行程并确认预订而对部分航线或房型特别开放的一种特惠价，是在零售指导价或优惠价的基础上，再享受额外价格优惠的船票价，适用“收费退订”政策。</div>
                    <div class="list-price-ins-head">优惠价</div>
                    <div class="list-price-ins-text">在零售指导价的基础上，享受了游轮公司品牌特惠和适用的限时闪惠（针对特定年龄或需使用优惠券或活动码等需经验证后方可享受的限时闪惠除外）后的船票价，适用“常规退订”政策。</div>

                    <div class="list-price-ins-head">零售指导价</div>
                    <div class="list-price-ins-text">即游轮公司根据市场情况制定和建议的船票零售价，并非中国法律法规所定义的“原价”，且可能由游轮公司不时调整，适用“常规退订”政策。</div>

                    <div class="list-price-ins-head">含税价格</div>
                    <div class="list-price-ins-text">价格标注“（含税）”的，则该价格已包含了在售房型相应的船票价格以及港务税费。</div>

                    <div class="list-price-ins-head">人均起价</div>
                    <div class="list-price-ins-text">价格标注“/人起”的，则该价格为各个在售房型根据人均计算的起价。人均价格仅为网页显示便利之目的而提供，同舱房每位客人的船票价会因入住人数和适用优惠而有所不同，请以最终订单显示为准。</div>

                    <div class="list-price-ins-head"></div>
                    <div class="list-price-ins-text">以上价格均未包含游轮服务费或其它收费或自费项目，并可能因实时库存变更、网络延迟或缓存等因素造成一定的误差，正式价格请以最终订单显示为准。</div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "CruisePricePopup",
    props: {
        isShow: {
            type: Boolean
        }
    },
    data () {
        return {
            isShowModal: false
        }
    },
    methods: {
        onModalClose () {
            this.isShowModal = false
            setTimeout(()=> {
                this.$emit('onModalClose')
            }, 100)
        }
    },
    watch: {
        isShow (newValue) {
            setTimeout(()=> {
                this.isShowModal = newValue
            }, 100)
        }
    }
}
</script>

<style lang="less" scoped>
.list-price-ins-head {
    font-size: 14px;
    color: #006ab9;
    margin: 12px 0 4px;
}

.modal.active {
    display: block;
}

.modal-bg {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.5);
}
</style>